import { render, staticRenderFns } from "./Modal-Composition.vue?vue&type=template&id=4e01b6e3&scoped=true&"
import script from "./Modal-Composition.vue?vue&type=script&lang=js&"
export * from "./Modal-Composition.vue?vue&type=script&lang=js&"
import style0 from "./Modal-Composition.vue?vue&type=style&index=0&id=4e01b6e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e01b6e3",
  null
  
)

export default component.exports